import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-2 sm:gap-4 bg-white px-4 pt-1 rounded-full" }

import { Progress, Tooltip } from 'ant-design-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkDownloadProgress',
  props: {
    total: {},
    success: {},
    failed: {}
  },
  setup(__props: any) {



function percent(value: number) {
	return Number(value.toFixed(2));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Tooltip), {
      title: `${_ctx.total - _ctx.success - _ctx.failed} to do / ${_ctx.success} done / ${_ctx.failed} failed / ${_ctx.total} total`
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Progress), {
          percent: percent(((_ctx.success + _ctx.failed) / _ctx.total) * 100),
          success: { percent: percent((_ctx.success / _ctx.total) * 100) },
          strokeColor: '#EF4444'
        }, null, 8, ["percent", "success"])
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}
}

})